export default {
	getUserAgentValue: function (key) {
		// var userAgent = this.getNavigator().userAgent;
		var userAgent = navigator.userAgent;

		var items = userAgent.split(' ');
		for (var i in items) {
			var item = items[i];
			var start = key + "=";
			var startIndex = item.indexOf(start);

			if (startIndex > -1) {
				var lastIndex = item.length;
				return item.substring(startIndex + key.length + 1, lastIndex);
			}
		}
		return "";
	},
	getDevideUuid: function () {
		return this.getUserAgentValue("deviceUuid");
	},
	isAndroid: function () {
		var platform = this.getUserAgentValue("platform");
		if (platform == 'AND') {
			return true;
		}

		return false;
	},
	isIos: function () {
		var platform = this.getUserAgentValue("platform");
		if (platform == 'IOS') {
			return true;
		}

		return false;
	},
	isPc: function () {
		var platform = this.getUserAgentValue("platform");
		if (platform == 'PC') {
			return true;
		}

		return false;

	},
	unsupported: function(pageName) {
		if(pageName == 'unsupported') {
			return false;
		}
		if(pageName == 'download') {
			return false;
		}
    if(pageName == 'chatbot') {
			return false;
		}
		if(pageName == 'cstmr-reg-by-cstmr' || pageName == 'cstmr-reg-by-cstmr-expired' || pageName == 'cstmr-reg-by-cstmr-complete' || pageName == 'cstmr-reg-by-cstmr-result') {
			return false;
		}
		if(this.isAndroid()) {
			return false;
		}
		if(this.isIos()) {
			return false;
		}
		if(this.isPc()) {
			return false;
		}
		return true;
	},
	guid: function () {
		function s4() {
			return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
		}
		// return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
		return s4() + s4() + '-' + s4() + '-' + s4();
	},
	getTopWindow: function(target) {
		var upper = target;
		var tmp = upper.opener;
		if(!tmp) {
			return upper;
		}
		return this.getTopWindow(tmp);
	},
	getWebkit: function() {
		var topWindow = this.getTopWindow(window);
		return topWindow.webkit;
	},
	getApp: function() {
		var topWindow = this.getTopWindow(window);
		return topWindow.app;
	},
	getNavigator: function() {
		// if (this.isIos()) {
		// 	return navigator;
		// }else if (this.isAndroid()) {
		// 	return navigator;
		// } else {
		// 	var topWindow = this.getTopWindow(window);
		// 	return topWindow.navigator;
		// }
		var topWindow = this.getTopWindow(window);
		return topWindow.navigator;
	}
}
